module.exports = __webpack_public_path__ + "static/media/hp_advice.cd1be9dd.svg";